import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectMeasurementNewDomain = (state) =>
  state.get("measurementNew", initialState)

const makeSelectMeasurementNew = () =>
  createSelector(selectMeasurementNewDomain, (state) => state.toJS())

export const makeSelectSegments = () =>
  createSelector(selectMeasurementNewDomain, (state) => state.get("segments"))
export const makeSelectIsLoadingSegments = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("isLoadingSegments")
  )
export const makeSelectSurveyTypes = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("surveyTypes")
  )
export const makeSelectIsLoadingSurveyTypes = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("isLoadingSurveyTypes")
  )
export const makeSelectScopeTypes = () =>
  createSelector(selectMeasurementNewDomain, (state) => state.get("scopeTypes"))
export const makeSelectIsLoadingScopeTypes = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("isLoadingScopeTypes")
  )
export const makeSelectIsLoadingCreateMeasurement = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("isLoadingCreateMeasurement")
  )
export const makeSelectOrganizationSurveys = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("organizationSurveys")
  )
export const makeSelectIsLoadingOrganizationSurveys = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("isLoadingOrganizationSurveys")
  )
export const makeSelectSegmentsSurveys = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("segmentsSurveys")
  )
export const makeSelectIsLoadingSegmentsSurveys = () =>
  createSelector(selectMeasurementNewDomain, (state) =>
    state.get("isLoadingSegmentsSurveys")
  )

export default makeSelectMeasurementNew
export { selectMeasurementNewDomain }
